module.exports = __webpack_public_path__ + "view.svg?c3b54ce02de175096819dda80e496e45";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/view.svg
// module id = 83
// module chunks = 0